exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loading[data-v-b8acc5ca] {\n  margin: 0 auto;\n  text-align: center;\n}\n", "", {"version":3,"sources":["F:/forex/web/forex-websrc/src/components/common/loading/loading.vue"],"names":[],"mappings":";AAAA;EACE,eAAe;EACf,mBAAmB;CAAE","file":"loading.vue","sourcesContent":[".loading {\n  margin: 0 auto;\n  text-align: center; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b8acc5ca","scoped":true,"sourceMap":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/loading/loading.vue
// module id = 500
// module chunks = 0 1